// extracted by mini-css-extract-plugin
export default {"profileCard":"EmailProfileCards_profileCard__-MBU5","studentImage":"EmailProfileCards_studentImage__RRgyJ"};